export default __webpack_public_path__ + "static/media/0x229b1b6c23ff8953d663c4cbb519717e323a0a84.b1fa01e9.jpeg";